module.exports = "pegasus_template/assets/icn_1.png";